export default __webpack_public_path__ + "static/elearning-and-coaching-apps-3667d3c4e930ab92ecc7c795ade8426d.pdf";